




















import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class DropDownFixData extends Vue { 
    @Prop() public changeState: any
    @Prop(String) readonly label!: string
    @Prop(String) readonly keyName!: string
    @Prop() readonly itemData: any
    @Prop() public trackid: any

	itemModel = null as any

	updateState () {
		if (this.itemModel !== null) this.changeState(`${this.keyName}`, this.itemModel.value)
		if (this.itemModel === null) this.changeState(`${this.keyName}`, "")
	}

  clear () {
		this.changeState(`${this.keyName}`, "")
		this.itemModel = null
	}
}
